import { Subscription, interval } from "rxjs";

import { DestroyRef, Signal, effect, inject } from "@angular/core";

export function registerDirtyRefresher(isDirty: Signal<boolean>, onRefresh: () => void, intervalMs = 5000): void {
  const destroyRef = inject(DestroyRef);
  let refresher: Subscription | undefined;

  effect(() => {
    if (isDirty()) {
      if (!refresher) {
        refresher = interval(intervalMs).subscribe(() => onRefresh());
      }
    } else {
      refresher?.unsubscribe();
      refresher = undefined;
    }
  });

  destroyRef.onDestroy(() => {
    refresher?.unsubscribe();
    refresher = undefined;
  });
}
